<template>
  <section class="c-section c-section--notices-single">
    <b-skeleton-wrapper :loading="contextLoading">
      <template #loading>
          <b-card class="p-0">
            <div class="container-fluid p-0">
              <div style="height:400px">
                <div class="w-100 d-flex justify-content-center">
                  <b-skeleton-img no-aspect width="100%" height="300px"></b-skeleton-img>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="d-flex justify-content-center">
                <b-col cols="10">
                  <b-skeleton-img height="500px"></b-skeleton-img>
                </b-col>
              </div>
            </div>
          </b-card>
      </template>
      <div v-if="context.post" class="c-banner-top c-banner-top--black">
        <div class="c-banner-top__gradient"></div>
        <div class="container position-relative h-100">
          <figure class="c-banner-top__semiluna">
            <img
              src="@/assets/images/semiluna.png"
              alt=""
              class="w-100 of--contain d-none d-md-block"
            >
          </figure>
          <div class="c-banner-top__contain me-md-5 pe-md-5">
            <div data-aos="fade-up" class="pe-md-5 me-md-5">
              <h1 class="white fs-45 w-black mb-3 pe-md-5 me-md-5">
                {{context.post.post_title}}
              </h1>
              <div class="d-flex">
                <router-link to="/" class="c-banner-top__link">
                  Inicio
                </router-link>
                <span class="mx-1 white fs-16 w-medium">/</span>
                <router-link to="/noticias" class="c-banner-top__link">
                  {{$route.name === 'Portafolio' ? 'Portafolio' : 'Noticias'}}
                </router-link>
                <span class="mx-1 white fs-16 w-medium">/</span>
                <p class="white fs-16 w-medium mb-0 pe-md-5 me-md-5">
                  {{context.post.post_title}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="c-notice">
        <div class="container">
          <div class="row gy-5 justify-content-center">
            <div class="col-12 col-md-10">
              <div>
                <figure data-aos="fade-up" class="c-notice__image mb-5">
                  <img :src="context.imagen_principal" alt="" class="w-100 h-100 of--cover">
                </figure>
                <div v-if="context.post" data-aos="fade-up" v-html="context.post.post_content"
                  class="sec-alt fs-16 w-medium line-height mb-5">
                </div>
              </div>
            </div>
            <div v-if="$route.name !== 'Portafolio'" class="col-12">
              <h2 data-aos="fade-up" class="c-notice__title mb-5">
                <strong>Noticias</strong> relacionadas
              </h2>
            <div v-if="context.articles" class="row gy-4 justify-content-center">
              <div
                v-for="(item,i) of context.articles"
                :key="`item-${i}`"
                data-aos="fade-up"
                :data-aos-delay="100 * (i + 1)"
                class="col-12 col-md-6 col-lg-3">
                <a :href="`/noticia/${item.slug}`" class="c-notice-card">
                  <div class="c-notice-card__container">
                    <figure class="c-notice-card__figure mb-3">
                      <img :src="item.thumbnail.src" alt="" class="w-100 h-100 of--cover">
                    </figure>
                    <p class="text-capitalize sec-alt fs-14 w-medium line-height mb-3 d-flex mb-0">
                      <span class="fs-25 d-flex me-2">
                        <Icon icon="healthicons:i-schedule-school-date-time-outline"/>
                      </span>
                      {{item.date}}
                    </p>
                    <h2 class="c-notice-card__title mb-3">
                      {{item.title}}
                    </h2>
                    <div class="c-notice-card__next">
                      <Icon icon="grommet-icons:link-next"/>
                    </div>
                    <div class="d-flex">
                      <p class="c-notice-card__mas">
                        <span class="me-1">
                          <Icon icon="grommet-icons:link-next"/>
                        </span>
                        Leer más
                      </p>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </b-skeleton-wrapper>
  </section>
</template>
<script>
export default {
  data() {
    return {
      test: null,
      context: {},
      contextLoading: true,
      formattedDate: new Date().toLocaleDateString('es-ES', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      }),
    };
  },
  created() {
    const newSlug = this.$route.params.single;
    this.getFullContext({ type: 'post-type', typeName: 'post', slug: newSlug });
  },
  filters: {
    formatoFecha: (value) => {
      const fecha = new Date(value);
      return fecha.toLocaleDateString('es-ES', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      });
    },
  },
  mounted() {
  },
};
</script>
